import { getOnboardingRequest, setOnboardingRequest } from './requests';

const onboardingSelector = state => state.onboarding;

export const getOnboardingSaga = async ({ action }) => {
  const data = await getOnboardingRequest(action.payload);
  return data;
};

export const setOnboardingSaga = async ({ action, getState }) => {
  const currentOnboarding = await onboardingSelector(getState());
  const data = await setOnboardingRequest({
    ...currentOnboarding,
    ...action.payload,
    tooltips: {
      ...currentOnboarding.tooltips,
      ...action.payload.tooltips,
    },
    intros: {
      ...currentOnboarding.intros,
      ...action.payload.intros,
    },
    dbValues: {
      ...currentOnboarding.dbValues,
    },
  });
  return data;
};
